import systemFeatureApi from '../../api/plan/systemFeatureApi';
import type { ApiResponse } from '../../types/common/ApiResponse';
import type { SystemFeatureMap } from '../../types/system/features';

const SystemFeatureService = {
  /**
   * Estado efectivo de todas las funcionalidades del sistema.
   * GET /api/system/features
   */
  fetchFeatures: async (): Promise<ApiResponse<SystemFeatureMap>> => {
    const response = await systemFeatureApi.fetchAll();
    return response.data;
  },
};

export default SystemFeatureService;
